import { timeMonth, timeWeek, timeYear } from 'd3-time';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

const xAxisTickFormatYear = (v) => dayjs(v).format('YYYY');

const defaultXAxisTickFns = {
    xAxisTickFormat: xAxisTickFormatYear,
    xAxisTickValues: timeYear,
};

export const getXAxisTickFns = (data) => {
    const tsLen = data?.[0]?.timeSeries?.length;
    if (!tsLen) return defaultXAxisTickFns;
    const firstDate = dayjs(data[0].timeSeries[1]?.[0]); // First date in series
    const lastDate = dayjs(data[0].timeSeries[tsLen - 1]?.[0]); // Last date
    const monthsDiff = lastDate.diff(firstDate, 'month');
    if (tsLen < 22 && monthsDiff <= 6)
        return {
            xAxisTickFormat: (v) => dayjs(v).format('MMM D'),
            xAxisTickValues: timeWeek.every(2),
        };
    if (tsLen < 52 && monthsDiff <= 12)
        return {
            xAxisTickFormat: (v) => dayjs(v).format('MMM'),
            xAxisTickValues: timeMonth.every(2),
        };
    return defaultXAxisTickFns;
};
